// TODO: replace string literals with variables - (phyoh)
import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  START_ACTIVATE_PREMIUM_TOP: '2935',
  START_ACTIVATE_PREMIUM_BOTTOM: '2936',
  START_ACTIVATE_FREEMIUM_TOP: '2937',
  START_ACTIVATE_FREEMIUM_BOTTOM: '2938',
  START_ACTIVATE_PREMIUM_FOOTER: '2939',
  ACTIVATE_LISTING: '2961',
} as const;

// https://dataportal.zillowgroup.net/event-registry/2935
const StartActivatePremiumTop = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.START_ACTIVATE_PREMIUM_TOP,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'posting_path',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'top_of_page',
      trigger_source_nm: 'publish_with_premium',
    },
    semantic: {
      semantic_event_nm: 'start_activate_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2936
const StartActivatePremiumBottom = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.START_ACTIVATE_PREMIUM_BOTTOM,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'posting_path',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'bottom_of_page',
      trigger_source_nm: 'publish_with_premium',
    },
    semantic: {
      semantic_event_nm: 'start_activate_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2937
const StartActivateFreemiumTop = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.START_ACTIVATE_FREEMIUM_TOP,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'posting_path',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'top_of_page',
      trigger_source_nm: 'publish_without_premium',
    },
    semantic: {
      semantic_event_nm: 'start_activate_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2938
const StartActivateFreemiumBottom = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.START_ACTIVATE_FREEMIUM_BOTTOM,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'posting_path',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'bottom_of_page',
      trigger_source_nm: 'publish_without_premium',
    },
    semantic: {
      semantic_event_nm: 'start_activate_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2939
const StartActivatePremiumFooter = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.START_ACTIVATE_PREMIUM_FOOTER,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'posting_path',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'footer_component',
      trigger_source_nm: 'go_premium',
    },
    semantic: {
      semantic_event_nm: 'start_activate_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2961
const ActivateListing = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.ACTIVATE_LISTING,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'posting_path',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'activate_listing',
    },
    semantic: {
      semantic_event_nm: 'activate_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const PayAndPublishCSEvents = {
  StartActivatePremiumTop,
  StartActivatePremiumBottom,
  StartActivateFreemiumTop,
  StartActivateFreemiumBottom,
  StartActivatePremiumFooter,
  ActivateListing,
};

// Clickstream visualizer data-eventid attributes
StartActivatePremiumTop.data_event_id = EVENT_IDS.START_ACTIVATE_PREMIUM_TOP;
StartActivatePremiumBottom.data_event_id = EVENT_IDS.START_ACTIVATE_PREMIUM_BOTTOM;
StartActivateFreemiumTop.data_event_id = EVENT_IDS.START_ACTIVATE_FREEMIUM_TOP;
StartActivateFreemiumBottom.data_event_id = EVENT_IDS.START_ACTIVATE_FREEMIUM_BOTTOM;
StartActivatePremiumFooter.data_event_id = EVENT_IDS.START_ACTIVATE_PREMIUM_FOOTER;
ActivateListing.data_event_id = EVENT_IDS.ACTIVATE_LISTING;

export default PayAndPublishCSEvents;
